import axios from "axios";
import { useState, useCallback } from "react";
import { toast } from "react-toastify";

const useGetDoctorSlots = () => {
  const [slots, setSlots] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getDoctorSlots = useCallback(async (doctorId, departmentId, date) => {
    if (!doctorId || !departmentId || !date) {
      setSlots([]);
      return;
    }

    setIsLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      // Convert DD/MM/YYYY to DD-MM-YYYY format
      const formattedDate = date.includes('/') ? date.replace(/\//g, '-') : date;
      
      const res = await axios.get(
        `/api/v1/phr-app/doctors/${doctorId}/slots`,
        {
          params: {
            department_id: departmentId,
            date: formattedDate,
          },
          headers: {
            Authorization: `Bearer ${token}`,
            "ngrok-skip-browser-warning": "hgs",
          },
        }
      );
      setSlots(res.data?.slots || []);
    } catch (error) {
      console.error(error, "error");
      // Don't show error toast for 404, 400, or External API errors - just show "No slots available" message
      if (error.response?.status === 404 || error.response?.status === 400) {
        setSlots([]);
        return;
      }
      
      const errorMessage = error.response?.data?.message || "";
      // Suppress "External API error" messages
      if (errorMessage.includes("External API error") || errorMessage.includes("Failed to fetch from PHR App API")) {
        setSlots([]);
        return;
      }
      
      if (!error.response) {
        toast.error("Oops, something went wrong");
      } else if (error.response?.status >= 500 && !errorMessage.includes("External API")) {
        // Only show toast for server errors (500+) that are not External API errors
        const messageContent = Array.isArray(errorMessage) ? (
          <ul className="ms-2 list-disc">
            {errorMessage.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        ) : (
          errorMessage || "An unknown error occurred"
        );
        toast.error(messageContent);
      } else if (error.response?.data?.statusCode === 401) {
        localStorage.removeItem("authToken");
        setTimeout(() => {
          window.location.href = "/";
        }, 1000);
      }
      // For other errors, just set empty array without showing toast
      setSlots([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    slots,
    isLoading,
    getDoctorSlots,
  };
};

export default useGetDoctorSlots;
